import slideLogo1 from "../../../assets/images/rrc/racoon.png";
export default function SlidingText() {
  return (
    <>
      {/* Sliding Text Start */}
      <section className="sliding-text-one">
        <div className="sliding-text-one__wrap">
          <ul className="sliding-text__list marquee_mode">
            <li>
              <h2 data-hover="Racket" className="sliding-text__title">
                Racket
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Riot" className="sliding-text__title">
                Riot
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Club" className="sliding-text__title">
                Club
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Racket" className="sliding-text__title">
                Racket
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Riot" className="sliding-text__title">
                Riot
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Club" className="sliding-text__title">
                Club
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
               <li>
              <h2 data-hover="Racket" className="sliding-text__title">
                Racket
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Riot" className="sliding-text__title">
                Riot
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Club" className="sliding-text__title">
                Club
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
               <li>
              <h2 data-hover="Racket" className="sliding-text__title">
                Racket
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Riot" className="sliding-text__title">
                Riot
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
            <li>
              <h2 data-hover="Club" className="sliding-text__title">
                Club
                <img src={slideLogo1} alt="Star Icon" />
              </h2>
            </li>
          </ul>
        </div>
      </section>
      {/* Sliding Text End */}
    </>
  );
}
